import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 请假列表
  leaveListToday(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_LIST_TODAY, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 请假详情
  leaveDetail(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_DETAIL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 请假记录
  leaveRecords(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_RECORDS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 发起请假(代)
  leaveApply(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_APPLY, postData)
        .then(res => {
          // 接口请求成功 重新赋值内部data
          if (typeof res.result === 'undefined') {
            if (res.resultCode === '0') {
              resolve(res.data)
            } else {
              resolve({
                ...res,
                result: res.resultCode,
                message: res.resultMsg
              })
            }
          } else {
            // 接口请求失败，走默认回显
            resolve(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 同意请假
  leaveAgree(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_AGREE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 拒绝请假
  leaveReject(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_REJECT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 撤销请假
  leaveCancel(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_CANCEL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 同意撤销请假申请
  leaveCancelAgree(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_CANCEL_AGREE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 同意撤销请假申请
  leaveCancelReject(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_CANCEL_REJECT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 统计待审核请假数量
  leaveAgentApplyCount(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_AGENT_APPLY_COUNT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 是否设置了审批流程
  existApprovalProcess(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_EXIST_APPROVAL_PROCESS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生请假记录导出
  exportLeaveRecordExcel(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_EXPORT_RECORD, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生请假记录导出进度查询
  getExportProgress(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_EXPORT_PROGRESS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生的标签和性别
  getLeaveStudentTagAndSex(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_STUDENT_TAG_AND_SEX, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假时间冲突的学生请假记录列表
  getConflictLeaveList(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CONFLICT_LEAVE_LIST, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假通行权限
  getLeavePermitDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_PERMIT_DEVICES, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑请假通行权限
  updateLeavePermitDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_LEAVE_PERMIT_DEVICES, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生请假通行设备
  updateLeavePermitDevicesV2(postData) {
    return http.post(URL.API_UPDATE_LEAVE_PERMIT_DEVICES_V2, postData)
  },
  // 查询家长请假可申请时间
  getAllowGuardianLeaveWeekdays(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_ALLOW_GUARDIAN_LEAVE_WEEKDAYS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑家长请假可申请时间
  updateAllowGuardianLeaveWeekDays(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_ALLOW_GUARDIAN_LEAVE_WEEKDAYS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询允许请假时段
  getAllowLeaveTimePeriod(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_ALLOW_LEAVE_TIME_PERIOD, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑请假允许时段
  updateAllowLeaveTimePeriod(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_ALLOW_LEAVE_TIME_PERIOD, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* ---------------- 通知 ---------------- */
  // 查询通知组列表
  getNoticeGroups(postData) {
    postData.campusId =
      window.localStorage.getItem('currentCapmusId') || postData.campusId
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_NOTICE_GROUPS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存通知组
  saveNoticeGroup(postData) {
    postData.campusId =
      window.localStorage.getItem('currentCapmusId') || postData.campusId
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_NOTICE_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取通知组详情
  getNoticeGroupDetail(postData) {
    postData.campusId =
      window.localStorage.getItem('currentCapmusId') || postData.campusId
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_NOTICE_GROUP_DETAIL, postData)
        .then(config => {
          resolve(config)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑通知组
  updateNoticeGroup(postData) {
    postData.campusId =
      window.localStorage.getItem('currentCapmusId') || postData.campusId
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_NOTICE_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除通知组
  deleteNoticeGroup(postData) {
    postData.campusId =
      window.localStorage.getItem('currentCapmusId') || postData.campusId
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DELETE_NOTICE_GROUP, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* ---------------- 通知 ---------------- */
  // 查询请假详情
  getLeaveDetail(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_DETAIL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 撤销请假
  cancelLeave(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CANCEL_LEAVE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 修改请假
  updateLeave(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_UPDATE_LEAVE, postData)
        .then(res => {
          // 接口请求成功 重新赋值内部data
          if (typeof res.result === 'undefined') {
            if (res.resultCode === '0') {
              resolve(res.data)
            } else {
              resolve({
                ...res,
                result: res.resultCode,
                message: res.resultMsg
              })
            }
          } else {
            // 接口请求失败，走默认回显
            resolve(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 请假
  leaveApplication(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_APPLICATION, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假单位
  getLeaveDurationUnit(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LEAVE_GET_DURATION_UNIT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑请假单位
  updateLeaveDurationUnit(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_LEAVE_UPDATE_DURATION_UNIT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 计算请假时长
  calculateLeaveDuration(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CALCULDATE_LEAVE_DURATION, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假时长明细
  getLeaveDurationDetail(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_DURATION_DETAIL, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假通行权限
  getLeavePermisionDevices(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_PERMISION_DEVICES, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询子部门
  getSubDept(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SUB_DEPT, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询子部门
  getClassStudentInfo(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_CLASS_STUDENT_INFO, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询是否允许学生发起请假
  getAllowStudentSubmitLeave(propsData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_LEAVE_ALLOW, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 编辑允许学生发起请假
  updateAllowStudentSubmitLeave(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SET_LEAVE_ALLOW, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 取消指令
  cancelCommand(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_COMMAND_CANCEL, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询指令
  queryCommand(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_COMMAND_QUERY, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 发送指令
  sendCommand(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_COMMAND_SEND, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 上报日志接口
  logCommand(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_COMMAND_LOG, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 校巴通知
  getSchoolBusNoticeDetail(propsData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCHOOL_BUS_NOTICE_DETAIL, propsData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询请假返校证明设置
  leaveBackConfigGet(postData) {
    return http.get(URL.API_LEAVE_BACK_CONFIG_GET, postData)
  },
  // 保存请假返校证明设置
  leaveBackConfigSave(postData) {
    return http.post(URL.API_LEAVE_BACK_CONFIG_SAVE, postData)
  },
  // 查询请假返校证明详情
  leaveBackGetDetail(postData) {
    return http.get(URL.API_LEAVE_BACK_GET_DETAIL, postData)
  },
  // 给家长发送提醒上传请假返校证明通知
  leaveBackNoticeGuardian(postData) {
    return http.post(URL.API_LEAVE_BACK_NOTICE_GUARDIAN, postData)
  },
  // 提交/重新提交请假返校证明
  leaveBackSubmit(postData) {
    return http.post(URL.API_LEAVE_BACK_SUBMIT, postData)
  },
  // 修改请假返校证明状态
  leaveBackUpdateStatus(postData) {
    return http.post(URL.API_LEAVE_BACK_UPDATE_STATUS, postData)
  },
  // 第三方授权协议
  getAppOrgAuthApplyList(postData) {
    return http.get(URL.API_ORG_AUTH_APPLY_LIST, postData)
  },
  // 查询请假外出通行模板详情
  getAuditTemplateAbsence(postData) {
    return http.get(URL.API_AUDIT_TEMPLATE_ABSENCE, postData)
  },
  // 请假外出通行开关切换
  toggleTemplateAbsenceStatus(postData) {
    return http.post(URL.API_AUDIT_TEMPLATE_ABSENCE_STATUS_TOGGLE, postData)
  },
  // 查询机构可管理的所有审批表单(钉钉OA)
  getAuditTemplateAbsenceForms(postData) {
    return http.get(URL.API_GET_APPROVAL_FORM_LIST, postData)
  },
  // 请假外出通行模板绑定表单及设备
  templateAbsenceBind(postData) {
    return http.post(URL.API_AUDIT_TEMPLATE_ABSENCE_BIND, postData)
  },
  // 职工请假通行列表
  getStaffPaDeviceList(postData) {
    return http.get(URL.API_AUDIT_GET_DEVICE_LIST, postData)
  },
  // 请假日统计
  getLeaveDayStat(postData) {
    return http.get(URL.API_LEAVE_GET_DAY_STAT, postData)
  },
  // 请假日统计详情
  getLeaveDayStatDetail(postData) {
    return http.get(URL.API_LEAVE_GET_DAY_STAT_DETAIL, postData)
  },
  // 查询请假类型
  getLeaveTypeGroup(postData) {
    return http.get(URL.API_LEAVE_GET_TYPE_GROUP, postData)
  },
  // 保存自定义请假类型
  saveCustomLeaveType(postData) {
    return http.post(URL.API_LEAVE_SAVE_CUSTOM_TYPE, postData)
  },
  // 删除保存自定义请假类型
  deleteCustomLeaveType(postData) {
    return http.post(URL.API_LEAVE_DELETE_CUSTOM_TYPE, postData)
  },
  // 根据模块查询灰度机构列表
  listBatchLeaveOrgId(postData) {
    return http.get(URL.API_LEAVE_BATCH_ORGIDS, postData)
  },
  // 批量请假
  batchLeave(postData) {
    return http.post(URL.API_LEAVE_BATCH, postData)
  },
  // 查询批量请假任务结果
  getBatchLeaveTaskResult(postData) {
    return http.get(URL.API_LEAVE_BATCH_TASK, postData)
  },
  // #region 请假自定义表单
  // 获取请假表单
  getCustomLeaveFrom(postData) {
    return http.post(URL.API_GET_CUSTOM_LEAVE_FORM, postData)
  },
  // 获取请假子类型
  getSubLeaveTypeList(postData) {
    return http.post(URL.API_GET_SUB_LEAVE_TYPE_LIST, postData)
  },
  // 更新请假子类型
  updateSubLeaveType(postData) {
    return http.post(URL.API_UPDATE_SUB_LEAVE_TYPE, postData)
  },
  // 获取请假升级状态
  getLeaveUpdateState(postData) {
    return http.post(URL.API_GET_LEAVE_UPDATE_STATE, postData)
  },
  // 设置请假升级状态
  setLeaveUpdateState(postData) {
    return http.post(URL.API_SET_LEAVE_UPDATE_STATE, postData)
  },
  // 查询自动销假开关状态
  getLeaveRevokeState(postData) {
    return http.post(URL.API_GET_LEAVE_REVOKE_STATE, postData)
  },
  // 设置自动销假开关状态
  setLeaveRevokeState(postData) {
    return http.post(URL.API_SET_LEAVE_REVOKE_STATE, postData)
  },
  // 主动销假
  checkOutLeave(postData) {
    return http.post(URL.API_CHECK_OUT_LEAVE, postData)
  },
  // 获取家长签到开关信息
  getLeaveParentSwitch(postData) {
    return http.post(URL.API_LEAVE_GET_PARENT_SWITCH, postData)
  },
  // 设置家长签到开关
  setLeaveParentSwitch(postData) {
    return http.post(URL.API_LEAVE_SET_PARENT_SWITCH, postData)
  },
  // 设置家长刷脸签到的设备列表
  setLeaveParentDeviceList(postData) {
    return http.post(URL.API_LEAVE_SET_DEVICE_LIST, postData)
  }
  // #endregion
}
